(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809],{

/***/ 21728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detailPackage",
      function () {
        return __webpack_require__(26703);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8745);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var TaggingGTM = function(props) {
    var ref;
    // 아래는 Google tag manager 관련
    var eventPriceFetch = (0,_QUERIES_prdt_event_useEventPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(props.query.evCd);
    var eventPrice = (ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!eventPrice) return;
        try {
            dataLayer.push({
                event: "addToCart",
                ecommerce: {
                    currencyCode: "KRW",
                    add: {
                        products: [
                            {
                                name: "".concat(props.eventDetail.evNm),
                                id: "".concat(props.goodsDetail.goodsCd),
                                price: "".concat(Number(eventPrice.adtPrice + eventPrice.bafAdtCost + eventPrice.airTaxAdtCost)),
                                category: "".concat(props.query.menu)
                            }, 
                        ]
                    }
                }
            });
        } catch (e) {
            ;
        }
    }, [
        eventPrice
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (TaggingGTM);


/***/ }),

/***/ 22476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fs": function() { return /* binding */ Assort; },
/* harmony export */   "Ik": function() { return /* binding */ ManagerBox; },
/* harmony export */   "Il": function() { return /* binding */ ScrollWrap; },
/* harmony export */   "Mh": function() { return /* binding */ TotalPrice; },
/* harmony export */   "PS": function() { return /* binding */ PriceWrap; },
/* harmony export */   "Q4": function() { return /* binding */ InfoList; },
/* harmony export */   "Xd": function() { return /* binding */ PriceText; },
/* harmony export */   "ZA": function() { return /* binding */ Age; },
/* harmony export */   "_G": function() { return /* binding */ ReservationButton; },
/* harmony export */   "a8": function() { return /* binding */ PriceInfo; },
/* harmony export */   "b0": function() { return /* binding */ DepartureWrap; },
/* harmony export */   "eq": function() { return /* binding */ DepartureButton; },
/* harmony export */   "fe": function() { return /* binding */ Reservation; },
/* harmony export */   "jL": function() { return /* binding */ Banner; },
/* harmony export */   "lU": function() { return /* binding */ TotalWrap; },
/* harmony export */   "sz": function() { return /* binding */ Discount; },
/* harmony export */   "wV": function() { return /* binding */ Coupon; },
/* harmony export */   "xZ": function() { return /* binding */ CouponWrap; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* unused harmony exports ReservationScrollWrap, Amount, ReservationPrice, Tooltip */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36432);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81499);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	top: 0;\n	float: right;\n	width: 260px;\n	margin-top: -7px;\n	border: 1px solid var(--placeholder-color);\n	border-radius: 8px;\n	box-sizing: border-box;\n	overflow: hidden;\n\n	",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 24px 0;\n	margin: 0 20px;\n	box-sizing: border-box;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	flex-direction: column;\n	gap: 15px;\n	line-height: 1;\n\n	li {\n		display: flex;\n		justify-content: space-between;\n		gap: 20px;\n\n		span {\n			color: var(--sub-title-color);\n			flex-shrink: 0;\n			font-size: var(--basic-size);\n			font-family: "PT-medium";\n		}\n\n		em {\n			color: var(--title-color);\n			font-family: "PT-semibold";\n			font-size: var(--basic-size);\n			',
        ";\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	padding: 24px 0;\n	margin: 0 20px;\n	border-top: 1px solid var(--line-color);\n	flex-direction: column;\n	gap: 20px;\n\n	li {\n		display: flex;\n		line-height: 1;\n		align-items: center;\n		justify-content: space-between;\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	span {\n		display: inline-flex;\n		align-items: center;\n		min-width: 25px;\n		font-family: "PT-medium";\n		font-size: var(--basic-size);\n		color: var(--sub-title-color);\n\n		+ span {\n			&::before {\n				display: block;\n				width: 18px;\n				line-height: 1;\n				height: 18px;\n				margin: 0 2px 0 3px;\n				background: url(',
        ') no-repeat -34px -372px;\n				content: "";\n			}\n		}\n	}\n'
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	width: 76px;\n	font-family: "PT-medium";\n	font-size: var(--small-size);\n	color: var(--sub-title-color);\n	em {\n		margin: 0 1px 0 9px;\n	}\n\n	span {\n		width: 30px;\n		text-align: right;\n	}\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	font-family: "PT-bold";\n	font-size: var(--default-size);\n	color: var(--title-color);\n\n	span {\n		font-family: "PT-semibold";\n		margin-left: 3px;\n	}\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	padding: 20px 0 24px;\n	margin: 0 20px;\n	border-top: 1px solid var(--line-color);\n	flex-direction: column;\n	gap: 8px;\n\n	button {\n		display: flex;\n		justify-content: center;\n		align-items: center;\n		gap: 6px;\n		height: 24px;\n		padding: 2px 8px;\n		border-radius: 8px;\n		border: 1px solid var(--brand-deep-color);\n		background: #fff9e8;\n		font-size: var(--small-size);\n		font-family: "PT-bold";\n		color: var(--brand-deep-color);\n\n		&::before {\n			display: flex;\n			width: 16px;\n			height: 16px;\n			background: url(',
        ') no-repeat 0 -372px;\n			content: "";\n		}\n	}\n\n	span {\n		line-height: 1.5;\n		font-size: var(--basic-size);\n		font-family: "PT-medium";\n		color: var(--sub-title-color);\n	}\n\n	> div:not(:first-of-type) {\n		padding-left: 16px;\n		box-sizing: border-box;\n		border-left: 2px solid var(--hr-color);\n	}\n\n	',
        " {\n		color: var(--alert-color);\n		> span {\n			color: var(--alert-color);\n		}\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 0 20px 24px;\n	text-align: right;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	flex-direction: column;\n	line-height: 1.5;\n	margin-bottom: 8px;\n	font-family: "PT-medium";\n	font-size: var(--regular-size);\n	text-align: right;\n	color: ',
        ';\n	strong {\n		font-family: "PT-bold";\n		font-size: 26px;\n	}\n'
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	font-family: "PT-medium";\n	font-size: var(--basic-size);\n	color: var(--primary-color);\n	> em {\n		font-family: "PT-bold";\n	}\n'
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	flex-direction: column;\n	align-items: flex-end;\n	margin-bottom: 16px;\n\n	button {\n		display: flex;\n		align-items: center;\n		line-height: 1.5;\n		background-color: #fff;\n		color: var(--sub-title-color);\n		font-family: "PT-medium";\n		font-size: var(--basic-size);\n		&::after {\n			display: block;\n			width: 18px;\n			height: 18px;\n			margin-left: 4px;\n			background: url(',
        ') no-repeat -16px -372px;\n			content: "";\n		}\n	}\n	p {\n		line-height: 1.5;\n		color: var(--sub-title-color);\n		font-family: "PT-medium";\n		font-size: var(--basic-size);\n	}\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: absolute;\n	top: -20px;\n	left: 50%;\n	z-index: 1;\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: fit-content;\n	height: 26px;\n	padding: 4px 16px;\n	border-radius: 6px;\n	border: 1px solid var(--border-color);\n	background-color: #fff;\n	transform: translateX(-50%);\n	filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.2));\n	box-sizing: border-box;\n\n	> p {\n		line-height: 1.5;\n		color: var(--title-color);\n		font-family: "PT-semibold";\n		font-size: var(--small-size);\n		white-space: nowrap;\n	}\n\n	&::after {\n		content: "";\n		position: absolute;\n		bottom: -6px;\n		left: 50%;\n		width: 11px;\n		height: 11px;\n		background-color: #fff;\n		border: 1px solid var(--border-color);\n		border-top: 0;\n		border-left: 0;\n		transform: translateX(-50%) rotate(45deg);\n		border-bottom-right-radius: 2px;\n		z-index: -1;\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n\n	&:has(",
        ") {\n		margin-top: 42px;\n	}\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	padding: 16px 20px;\n	background-color: var(--label-bg-color);\n	dl {\n		display: flex;\n		flex-wrap: wrap;\n		gap: 4px 8px;\n		font-size: var(--basic-size);\n	}\n\n	dt {\n		line-height: 1.5;\n		font-family: "PT-medium";\n		color: var(--sub-title-color);\n	}\n	dd {\n		position: relative;\n		line-height: 1.5;\n		color: var(--title-color);\n		font-family: "PT-semibold";\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	overflow-y: auto;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 5px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 16px;\n	width: 100%;\n	font-size: var(--default-size);\n	background-color: var(--title-color);\n	color: #fff;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	/* height: calc(100vh - 301px); */\n	// 옵션이 없을 경우\n	/* max-height: ",
        "; */\n	overflow-y: auto;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: block;\n	margin-top: 24px;\n	width: 100%;\n\n	img {\n		width: 218px;\n	}\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	width: 100%;\n	height: 56px;\n	font-family: "PT-bold";\n	font-size: var(--medium-size);\n	background-color: var(--brand-color);\n	padding: 4px 16px;\n	/* color: ',
        "; */\n	color: var(--title-color);\n\n	",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}




var Box = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-0"
})(_templateObject(), function(props) {
    return props.isFixed === false && "\n		position: static;\n	";
});
var DepartureWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-1"
})(_templateObject1());
var InfoList = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({
    componentId: "sc-194e98ff-2"
})(_templateObject2(), (0,_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_2__/* .Ellipsis */ .mH)(1));
var PriceWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({
    componentId: "sc-194e98ff-3"
})(_templateObject3());
var Amount = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    componentId: "sc-194e98ff-4"
})(_templateObject4(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3___default()));
var Age = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    componentId: "sc-194e98ff-5"
})(_templateObject5());
var PriceText = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    componentId: "sc-194e98ff-6"
})(_templateObject6());
var Coupon = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    componentId: "sc-194e98ff-7"
})(_templateObject7());
var Discount = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    componentId: "sc-194e98ff-8"
})(_templateObject8());
var CouponWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-9"
})(_templateObject9(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3___default()), Discount);
var TotalWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-10"
})(_templateObject10());
var TotalPrice = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-11"
})(_templateObject11(), function(param) {
    var $disabled = param.$disabled;
    return $disabled ? "var(--disable-text-color)" : "var(--title-color)";
});
var ReservationPrice = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].p.withConfig({
    componentId: "sc-194e98ff-12"
})(_templateObject12());
var PriceInfo = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-13"
})(_templateObject13(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_3___default()));
var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-14"
})(_templateObject14());
var Reservation = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-15"
})(_templateObject15(), Tooltip);
var ManagerBox = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-16"
})(_templateObject16());
var ScrollWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-17"
})(_templateObject17());
var Assort = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-18"
})(_templateObject18());
var DepartureButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_1__/* .TextDefaultButton */ .mm).withConfig({
    componentId: "sc-194e98ff-19"
})(_templateObject19());
var ReservationScrollWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-194e98ff-20"
})(_templateObject20(), function(props) {
    return props.isOption ? "324px;" : "295px;";
});
var Banner = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a.withConfig({
    componentId: "sc-194e98ff-21"
})(_templateObject21());
var ReservationButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_1__/* .TextDefaultButton */ .mm).withConfig({
    componentId: "sc-194e98ff-22"
})(_templateObject22(), function(param) {
    var waiting = param.waiting;
    return waiting ? "#fff" : "var(--title-color)";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "\n		background-color: var(--disable-text-color);\n		color: #fff;\n		cursor: unset;" : "";
});



/***/ }),

/***/ 26195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CountingWrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	button {\n		width: 32px;\n		height: 32px;\n		border: 1px solid var(--border-color);\n\n		&:before {\n			top: 50%;\n			left: 50%;\n			transform: translate(-50%, -50%);\n		}\n\n		&:after {\n			top: 50%;\n			left: 50%;\n			transform: translate(-50%, -50%);\n		}\n\n		&:first-of-type {\n			border-radius: 4px 0 0 4px;\n			&:before {\n				width: 12px;\n				border-radius: 2px;\n			}\n			&:disabled {\n				&:before {\n					background-color: #9a9a9a;\n				}\n			}\n		}\n\n		&:last-of-type {\n			border-radius: 0 4px 4px 0;\n			&:before {\n				height: 12px;\n				border-radius: 2px;\n			}\n			&:after {\n				width: 12px;\n				border-radius: 2px;\n			}\n			&:disabled {\n				&::before,\n				&::after {\n					background-color: #9a9a9a;\n				}\n			}\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 40px;\n	height: 32px;\n	padding: 10px 5px;\n	font-size: 15px;\n	border-color: var(--border-color);\n	border-left: 0;\n	border-right: 0;\n	text-align: center;\n	color: ",
        ';\n	font-family: "PT-semibold";\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CountingWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-56a0fcbf-0"
})(_templateObject());
var NumberInput = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
    componentId: "sc-56a0fcbf-1"
})(_templateObject1(), function(param) {
    var $isMinValue = param.$isMinValue;
    return $isMinValue ? "var(--placeholder-color)" : "var(--sub-title-color)";
});
var CountingButton = function(param) {
    var increase = param.increase, decrease = param.decrease, onClick = param.onClick, value = param.value, _minValue = param.minValue, minValue = _minValue === void 0 ? 0 : _minValue;
    var maxValue = 30;
    var onIncrease = function() {
        var increaseNumber = value + 1;
        typeof increase === "function" && increase(increaseNumber);
        typeof onClick === "function" && onClick("plus", increaseNumber);
    };
    var onDecrease = function() {
        var decreasedNumber = Math.max(value - 1, 0);
        typeof decrease === "function" && decrease(decreasedNumber);
        typeof onClick === "function" && onClick("minus", decreasedNumber);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CountingWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__/* .NumberButton */ ._7, {
                types: "minus",
                onClick: onDecrease,
                disabled: value <= minValue
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NumberInput, {
                width: "38px",
                value: value,
                readOnly: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_2__/* .NumberButton */ ._7, {
                types: "plus",
                onClick: onIncrease,
                disabled: value >= maxValue
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CountingButton);



/***/ }),

/***/ 72326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);




var key = "useRcmnOfSimList";
/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/ var getPath = function() {
    return "/bff/chorus/braze/rcmnOfSimList";
};
/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/ var useRcmnOfSimList = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(),
                method: "POST",
                data: {
                    evCd: evCd
                }
            }).then(function(r) {
                var ref;
                // TYPE_0 은 현재 상품과 동일, 그래서 제외
                var filteredList = ((ref = r.data.crmRcmnSearchSimResultList) !== null && ref !== void 0 ? ref : []).filter(function(v) {
                    return v.type !== "TYPE_0";
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, r.data), {
                    crmRcmnSearchSimResultList: filteredList
                });
            });
        },
        staleTime: 1000 * 30 * 60,
        throwOnError: true
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useRcmnOfSimList);



/***/ }),

/***/ 70189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 쿠폰 리스트 조회 by user
 *   `/pkg/coupon/by-event/${evCd}/${webCustNo}`
 * parameter
 *   `evCd` 예약자 일련번호
 *   `webCustNo` 회원 일련번호
 * ```*/ var key = "useCouponByUser";
var getPath = function(evCd, webCustNo) {
    if (!evCd || !webCustNo) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/coupon/by-event/").concat(evCd, "/").concat(webCustNo);
};
var useCouponByUser = function(evCd, webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd, webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd, webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 0,
        gcTime: 0
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCouponByUser);



/***/ }),

/***/ 69230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$o": function() { return /* binding */ eventAvailabilityAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);






/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useCode";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/availability");
};
/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventAvailabilityAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(evCd) {
        var result, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = getPath(evCd), _tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function eventAvailabilityAsync(evCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventAvailability = function(evCd, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useEventAvailability)));



/***/ }),

/***/ 98846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports eventMileageAsync, eventMileageSSR, getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventMileage";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/expect-mileage");
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventMileageAsync = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventMileageSSR = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventMileage = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventMileage);



/***/ }),

/***/ 13028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useEventPromotion";
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/pkg/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/promotion");
};
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/pkg/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventPromotion = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventPromotion);



/***/ }),

/***/ 26703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ detailPackage_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
// EXTERNAL MODULE: ./components/layout/breadcrumbs/desktop/index.tsx + 1 modules
var desktop = __webpack_require__(96646);
// EXTERNAL MODULE: ./components/layout/footer/Desktop/index.tsx + 1 modules
var Desktop = __webpack_require__(19145);
// EXTERNAL MODULE: ./components/layout/header/Desktop/index.tsx + 8 modules
var header_Desktop = __webpack_require__(2370);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/common/GTMTags.tsx
var GTMTags = __webpack_require__(9946);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailContents.tsx + 1 modules
var DetailContents = __webpack_require__(36017);
// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailHeader.tsx + 1 modules
var DetailHeader = __webpack_require__(29624);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionlink.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 910px;\n	margin: 60px auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	width: 100%;\n	margin-top: 20px;\n	border: 1px solid var(--yellow-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--default-size);\n	+ li {\n		border-top: 1px solid var(--yellow-color);\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: space-between;\n	padding: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	white-space: nowrap;\n	margin-left: 10px;\n	border-bottom: 1px solid var(--default-color);\n	&::after {\n		display: inline-block;\n		width: 7px;\n		height: 7px;\n		margin-top: 2px;\n		margin-left: 5px;\n		border-top: 1px solid var(--default-color);\n		border-left: 1px solid var(--default-color);\n		transform: rotate(135deg);\n		content: "";\n	}\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3727a3f2-0"
})(_templateObject());
var LinkList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-3727a3f2-1"
})(_templateObject1());
var LinkListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-3727a3f2-2"
})(_templateObject2());
var Link = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-3727a3f2-3"
})(_templateObject3());
var LinkTitle = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-3727a3f2-4"
})(_templateObject4(), (0,desktop_text/* Ellipsis */.mH)(1));
var LinkArrow = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-3727a3f2-5"
})(_templateObject5());


// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPromotion.ts
var useEventPromotion = __webpack_require__(13028);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailPromotion.tsx










var DetailPromotionComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useEvtPromotion = (0,useEventPromotion/* default */.ZP)(evCd);
    var promotionList = ((ref = useEvtPromotion.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl", {
        selectDiv: "relatedBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: promotionList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "관련 기획전"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkList, {
                    children: promotionList.map(function(param, index) {
                        var mstLink = param.mstLink, mstNm = param.mstNm;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkListItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(mstLink),
                                onClick: function(e) {
                                    e.preventDefault();
                                    taggingClick({
                                        link: mstLink,
                                        title: mstNm
                                    });
                                    (0,commonUtil/* onClickSSO */.Zy)(e, "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(mstLink));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTitle, {
                                        dangerouslySetInnerHTML: {
                                            __html: mstNm.replaceAll(/<br\s*\/?>/gi, "")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkArrow, {
                                        children: "기획전 바로가기"
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/** 관련 기획전*/ var DetailPromotion = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailPromotion Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailPromotionComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailPromotion = (/*#__PURE__*/(0,react.memo)(DetailPromotion));

// EXTERNAL MODULE: ./components/common/ssoLink/index.tsx
var ssoLink = __webpack_require__(50142);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
;// CONCATENATED MODULE: ./components/style/detailpackage/promotionproduct.tsx

function promotionproduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 60px auto;\n"
    ]);
    promotionproduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 100%;\n	padding-top: 20px;\n	margin-top: 20px;\n	border-top: 1px solid var(--line-color);\n"
    ]);
    promotionproduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	cursor: pointer;\n"
    ]);
    promotionproduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	width: 285px;\n	height: 195px;\n	/* background: #f7f7f7 url(",
        ") center / 100% no-repeat; */\n	> img:not(.fallback_thumb) {\n		width: 100%;\n		height: 100%;\n		object-fit: cover;\n	}\n"
    ]);
    promotionproduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 15px;\n	background: #fff;\n	color: var(--default-color);\n"
    ]);
    promotionproduct_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function promotionproduct_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	height: 48px;\n	margin-bottom: 8px;\n	font-family: "PT-medium";\n	font-size: 16px;\n	line-height: 24px;\n	color: var(--emp-color);\n	',
        ";\n"
    ]);
    promotionproduct_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--default-size);\n	color: var(--default-color);\n\n	> em {\n		margin-right: 10px;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: flex-end;\n	justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-top: 10px;\n	margin-left: auto;\n	font-size: var(--basic-size);\n	color: var(--red-color);\n	line-height: 1;\n	text-align: right;\n\n	strong {\n		margin-right: 3px;\n		font-size: 20px;\n		font-family: "PT-medium";\n		font-weight: normal;\n	}\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 55px;\n	height: 55px;\n	padding: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	button {\n		position: absolute;\n		top: 50%;\n		width: 40px;\n		height: 40px;\n		border: 1px solid #d0d0d0;\n		border-radius: 50%;\n		background-color: #fff;\n		transform: translateY(-50%);\n\n		&:after {\n			position: absolute;\n			top: 16px;\n			display: block;\n			width: 6px;\n			height: 6px;\n			border-top: 1px solid #848484;\n			border-right: 1px solid #848484;\n			font-size: 0;\n			content: "";\n		}\n		&:hover:not(:disabled) {\n			background-color: #333;\n			border-color: #333;\n			&:after {\n				border-top: 1px solid #fff;\n				border-right: 1px solid #fff;\n			}\n		}\n		&:disabled {\n			border: 1px solid #e5e5e5;\n			cursor: unset;\n			&::after {\n				border-top: 2px solid #e5e5e5;\n				border-right: 2px solid #e5e5e5;\n			}\n		}\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	right: -60px;\n\n	&:after {\n		right: 17px;\n		transform: rotate(45deg);\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	left: -60px;\n	&:after {\n		left: 17px;\n		transform: rotate(-135deg);\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var promotionproduct_Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-0"
})(promotionproduct_templateObject());
var SlideWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-1"
})(promotionproduct_templateObject1());
var Slider = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-3765f39a-2"
})(promotionproduct_templateObject2());
var SlideImg = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-3"
})(promotionproduct_templateObject3(), (ico_nodata_default()));
var InfoBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-4"
})(promotionproduct_templateObject4());
var SlideTitle = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-5"
})(promotionproduct_templateObject5(), (0,desktop_text/* Ellipsis */.mH)(2));
var promotionproduct_Date = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-6"
})(_templateObject6());
var InfoBottomBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-7"
})(_templateObject7());
var Price = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-8"
})(_templateObject8());
var Tag = (0,styled_components_browser_esm["default"])(flag/* TagSquare */.IO).withConfig({
    componentId: "sc-3765f39a-9"
})(_templateObject9());
var SlideButtonWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3765f39a-10"
})(_templateObject10());
var SlideNextbutton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-3765f39a-11"
})(_templateObject11());
var SlidePrevbutton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-3765f39a-12"
})(_templateObject12());


// EXTERNAL MODULE: ./framework/ui/desktop/slide/index.ts + 6 modules
var slide = __webpack_require__(93774);
// EXTERNAL MODULE: ./hooks/services/queries/chorus/rcmn/useRcmnOfSimList.ts
var useRcmnOfSimList = __webpack_require__(72326);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailRecommend.tsx













var DetailRecommendComponent = function(query) {
    var evCd = query.evCd;
    /** 추천상품 조회 */ var rcmnOfSimListFetch = (0,useRcmnOfSimList/* default */.ZP)(evCd, {
        placeholderData: {
            crmRcmnSearchSimResultList: [],
            errorCode: "",
            errorMsg: ""
        }
    });
    var recommendList = rcmnOfSimListFetch.data.crmRcmnSearchSimResultList || [];
    var swiperRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: recommendList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproduct_Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                    children: "추천 상품"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* RecommendationSlide */.OQ, {
                    perView: 4,
                    spaceBetween: 20,
                    ref: swiperRef,
                    children: recommendList.slice(0, 10) // 최대 10개만 노출
                    .map(function(recommend, index) {
                        var outStartDt = recommend.outStartDt, adtPrice = recommend.adtPrice, landing = recommend.landing, imageThum1 = recommend.imageThum1, evNm = recommend.evNm;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ssoLink/* default */.Z, {
                                href: landing,
                                target: "_blank",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideImg, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                            src: imageThum1 || "",
                                            alt: "상품 이미지",
                                            width: "285px",
                                            height: "195px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideTitle, {
                                                children: evNm
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(promotionproduct_Date, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: "출발일"
                                                    }),
                                                    dayjs_min_default()(outStartDt).format("YYYY.MM.DD")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBottomBlock, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(adtPrice)
                                                        }),
                                                        "원"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
var DetailRecommend = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailRecommend Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailRecommendComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailRecommend = (DetailRecommend);

// EXTERNAL MODULE: ./components/product/pages/detailPackage/desktop/DetailSchedule.tsx + 7 modules
var DetailSchedule = __webpack_require__(2045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var alert_Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
// EXTERNAL MODULE: ./framework/ui/desktop/input/RadioN.tsx
var RadioN = __webpack_require__(73882);
;// CONCATENATED MODULE: ./components/style/detailpackage/couponselectpopup.tsx

function couponselectpopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 24px 24px 32px;\n"
    ]);
    couponselectpopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 24px;\n	padding-bottom: 24px;\n	border-bottom: 1px solid var(--hr-color);\n"
    ]);
    couponselectpopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	margin-bottom: 8px;\n	font-family: "PT-semibold";\n	font-size: 14px;\n	color: var(--sub-title-color);\n'
    ]);
    couponselectpopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 8px;\n	width: 100%;\n"
    ]);
    couponselectpopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex: 1;\n	gap: 8px;\n	overflow: hidden;\n\n	> div:last-of-type {\n		overflow: visible;\n	}\n"
    ]);
    couponselectpopup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					position: relative;\n					width: 100%;\n					height: 56px;\n					padding: 16px;\n					border: 1px solid var(--hr-color);\n					border-radius: 8px;\n					> ",
        " {\n						width: 100%;\n						> label {\n							position: absolute;\n							z-index: 1;\n							inset: 0;\n							display: flex;\n							align-items: center;\n							padding-top: 2px;\n							padding-left: 48px;\n							box-sizing: border-box;\n						}\n					}\n				"
    ]);
    couponselectpopup_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					",
        " {\n						padding: 16px 16px 14px 16px;\n						border: 1px solid var(--line-color);\n						border-right-color: var(--hr-color);\n						border-radius: 8px;\n					}\n				"
    ]);
    couponselectpopup_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n\n	> ",
        " {\n		gap: 8px;\n	}\n\n	",
        ";\n"
    ]);
    couponselectpopup_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	width: 100%;\n	cursor: pointer;\n"
    ]);
    couponselectpopup_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 30px;\n	height: 30px;\n	background-image: url(",
        ");\n	background-position: -344px 0px;\n"
    ]);
    couponselectpopup_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			pointer-events: none;\n\n			> p {\n				background-color: #bdbdbd;\n				color: #fff;\n			}\n		"
    ]);
    couponselectpopup_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			> ",
        " {\n				display: none;\n			}\n		"
    ]);
    couponselectpopup_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function couponselectpopup_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	justify-content: center;\n	gap: 3px;\n	width: 82px;\n	height: 100%;\n	margin-left: -1px;\n	border: 1px solid var(--line-color);\n	border-left-color: var(--hr-color);\n	border-radius: 8px;\n	background-color: #fff;\n\n	> p {\n		border-radius: 8px;\n		background-color: var(--brand-color);\n		font-size: 12px;\n		font-family: "PT-bold";\n		width: 54px;\n		height: 20px;\n		padding: 0 6px;\n		line-height: 20px;\n		box-sizing: border-box;\n		color: #fff;\n		white-space: nowrap;\n	}\n\n	',
        "\n\n	",
        '\n\n	&::before,\n	&::after {\n		position: absolute;\n		display: block;\n		width: 8px;\n		height: 8px;\n		background-color: #fff;\n		content: "";\n	}\n	&::before {\n		top: 8px;\n		left: -4px;\n	}\n	&::after {\n		bottom: 8px;\n		left: -4px;\n	}\n'
    ]);
    couponselectpopup_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	gap: 6px;\n	overflow: hidden;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	margin-top: 12px;\n	padding-left: 10px;\n	font-size: 14px;\n	color: var(--caption-color);\n	line-height: 1.5;\n\n	&::before {\n		position: absolute;\n		top: 8px;\n		left: 0;\n		width: 4px;\n		height: 4px;\n		border-radius: 50%;\n		background: var(--disable-text-color);\n		content: "";\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 6px;\n	flex: 0 0 auto;\n	line-height: normal;\n	color: var(--alert-color);\n	font-family: "PT-bold";\n	font-size: 18px;\n	white-space: nowrap;\n	flex-wrap: wrap;\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	gap: 4px;\n	flex-wrap: wrap;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			border-color: var(--alert-color);\n			background-color: var(--alert-color);\n			color: #fff;\n			border-radius: 8px 8px 8px 0;\n		"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			border-color: var(--alert-color);\n			background-color: #ffeceb;\n			color: var(--alert-color);\n		"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: inline-flex;\n	align-items: center;\n	height: 18px;\n	line-height: 18px;\n	padding: 0 8px;\n	border-radius: 8px;\n	border: 1px solid var(--line-color);\n	font-family: "PT-bold";\n	font-size: 11px;\n	white-space: nowrap;\n	color: var(--caption-color);\n	box-sizing: border-box;\n\n	',
        "\n\n	",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	flex: 0 0 auto;\n	line-height: normal;\n	font-family: "PT-semibold";\n	font-size: 14px;\n	color: var(--sub-title-color);\n	display: -webkit-box;\n	-webkit-box-orient: vertical;\n	-webkit-line-clamp: 3;\n	overflow: hidden;\n	white-space: normal;\n	word-break: break-all;\n	text-overflow: ellipsis;\n'
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	justify-content: space-between;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	gap: 4px;\n	font-size: 16px;\n	font-family: "PT-bold";\n	color: var(--title-color);\n	line-height: 1.5;\n'
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	width: 20px;\n	height: 20px;\n	background-image: url(",
        ");\n	background-position: -53px -371px;\n	background-color: transparent;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-size: 18px;\n	font-family: "PT-medium";\n	color: var(--alert-color);\n	line-height: 1.5;\n\n	> em {\n		font-family: "PT-bold";\n	}\n'
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	left: 50%;\n	transform: translateX(-50%);\n	bottom: 36px;\n	z-index: 1;\n	display: inline-flex;\n	width: 100%;\n	padding: 16px;\n	border-radius: 8px;\n	border: 1px solid var(--border-color);\n	background: var(--disable-bg-color);\n	box-sizing: border-box;\n\n	&::before {\n		position: absolute;\n		bottom: -6px;\n		left: 71px;\n		transform: translateX(-50%) rotate(45deg);\n		width: 11px;\n		height: 11px;\n		background: var(--disable-bg-color);\n		border-right: 1px solid var(--border-color);\n		border-bottom: 1px solid var(--border-color);\n		border-radius: 0 0 2px 0;\n		content: "";\n		z-index: 2;\n	}\n\n	> ul {\n		display: flex;\n		flex-direction: column;\n		gap: 6px;\n\n		li {\n			position: relative;\n			padding-left: 10px;\n			font-size: 14px;\n			font-family: "PT-medium";\n			color: var(--caption-color);\n			line-height: 1.5;\n\n			&::before {\n				position: absolute;\n				top: 8px;\n				left: 0;\n				width: 4px;\n				height: 4px;\n				border-radius: 50%;\n				background: var(--disable-text-color);\n				content: "";\n			}\n		}\n	}\n'
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	line-height: 1;\n	padding: 16px;\n	height: 56px;\n	border-radius: 8px;\n	border: 1px solid var(--hr-color);\n	font-size: 14px;\n	color: var(--caption-color);\n	font-family: "PT-medium";\n	box-sizing: border-box;\n'
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



var CouponSelectContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-0"
})(couponselectpopup_templateObject());
var CouponSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-1"
})(couponselectpopup_templateObject1());
var CouponSectionTitle = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-983abbf2-2"
})(couponselectpopup_templateObject2());
var CouponList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-983abbf2-3"
})(couponselectpopup_templateObject3());
var CouponInfo = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-4"
})(couponselectpopup_templateObject4());
var CouponListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-983abbf2-5"
})(couponselectpopup_templateObject7(), RadioN/* RadioWrap */.M, function(param) {
    var isNone = param.isNone;
    return isNone ? (0,styled_components_browser_esm.css)(couponselectpopup_templateObject5(), RadioN/* RadioWrap */.M) : (0,styled_components_browser_esm.css)(couponselectpopup_templateObject6(), CouponInfo);
});
var CouponItem = styled_components_browser_esm["default"].label.withConfig({
    componentId: "sc-983abbf2-6"
})(couponselectpopup_templateObject8());
var CouponDownloadIcon = styled_components_browser_esm["default"].i.withConfig({
    componentId: "sc-983abbf2-7"
})(couponselectpopup_templateObject9(), (ico_spr_default()));
var CouponDownloadBtn = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-983abbf2-8"
})(couponselectpopup_templateObject12(), function(param) {
    var soldOut = param.soldOut;
    return soldOut && (0,styled_components_browser_esm.css)(couponselectpopup_templateObject10());
}, function(param) {
    var downloaded = param.downloaded, soldOut = param.soldOut;
    return (downloaded || soldOut) && (0,styled_components_browser_esm.css)(couponselectpopup_templateObject11(), CouponDownloadIcon);
});
var CouponText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-983abbf2-9"
})(_templateObject13());
var CouponNotice = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-983abbf2-10"
})(_templateObject14());
var CouponBadge = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-983abbf2-11"
})(_templateObject15());
var CouponTagGroup = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-983abbf2-12"
})(_templateObject16());
var CouponTag = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-983abbf2-13"
})(_templateObject19(), function(param) {
    var type = param.type;
    return type === "limited" && (0,styled_components_browser_esm.css)(_templateObject17());
}, function(param) {
    var type = param.type;
    return type === "impending" && (0,styled_components_browser_esm.css)(_templateObject18());
});
var CouponName = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-983abbf2-14"
})(_templateObject20());
var DiscountSummary = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-15"
})(_templateObject21());
var DiscountSummaryLabel = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-983abbf2-16"
})(_templateObject22());
var TooltipButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-983abbf2-17"
})(_templateObject23(), (ico_spr_default()));
var DiscountSummaryAmount = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-983abbf2-18"
})(_templateObject24());
var Tooltip = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-19"
})(_templateObject25());
var EmptyCouponbox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-983abbf2-20"
})(_templateObject26());


// EXTERNAL MODULE: ./framework/ui/desktop/popup/PopupConfirm.tsx
var PopupConfirm = __webpack_require__(54195);
// EXTERNAL MODULE: ./hooks/services/queries/account/useCustomerMe.ts + 1 modules
var useCustomerMe = __webpack_require__(38186);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponByUser.ts
var useCouponByUser = __webpack_require__(70189);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/coupon/useCouponDown.ts
var useCouponDown = __webpack_require__(46894);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/CouponPopup.tsx




















/** 선착순 쿠폰 마감임박 잔여 수량 기준 */ var FCFS_IMMINENT_REMAIN_CNT = 20;
var CouponPopup_CouponItem = function(props) {
    var index = props.index, calcObj = props.calcObj, couponNo = props.couponNo, couponNm = props.couponNm, couponDivi = props.couponDivi, downYn = props.downYn, discDiviCd = props.discDiviCd, discAmt = props.discAmt, discRate = props.discRate, fcfsYn = props.fcfsYn, remainCnt = props.remainCnt, handleRadio = props.handleRadio, webCustNo = props.webCustNo, evCd = props.evCd;
    var nameText = props.multiUseYn === "Y" ? "duplicateCoupon" : "availableCoupon";
    var id = (0,react.useId)();
    var radioId = "".concat(nameText).concat(id).concat(index);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var isFcfs = fcfsYn === "Y";
    var remain = Number(remainCnt);
    var isSoldOut = isFcfs && remain <= 0;
    var isImpending = isFcfs && !isSoldOut && remain <= FCFS_IMMINENT_REMAIN_CNT;
    var needDownload = downYn === "Y" && couponDivi === "BA" && !isSoldOut;
    var isRadioDisabled = isSoldOut || downYn === "Y" && couponDivi === "BA";
    var handleDown = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var body, _tmp, result, data, _tmp1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        if (isSoldOut) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp = {};
                        body = (_tmp.compId = "1", _tmp.webCustNo = webCustNo, _tmp.couponNo = couponNo, _tmp);
                        return [
                            4,
                            (0,useCouponDown/* default */.Z)(body)
                        ];
                    case 2:
                        result = _state.sent();
                        data = result.data;
                        _tmp1 = {};
                        if (data.errorCode === "0000") {
                            queryClient.refetchQueries((_tmp1.queryKey = [
                                "useCouponByUser"
                            ], _tmp1.type = "active", _tmp1));
                        } else {
                            alert(data.errorMsg);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        alert("오류가 발생하였습니다.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDown(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("goods_down_coupon", {
        evCd: evCd,
        selectDiv: "availableCoupon"
    }).taggingClick;
    var discountBadge = discDiviCd === "M" ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(discAmt), "원") : "".concat(discRate, "%");
    var downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadBtn, {
        type: "button",
        downloaded: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "사용가능"
        })
    });
    if (isSoldOut) {
        downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadBtn, {
            type: "button",
            soldOut: true,
            disabled: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "마감"
            })
        });
    } else if (needDownload) {
        downloadButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponDownloadBtn, {
            type: "button",
            onClick: function(e) {
                handleDown(e);
                taggingClick(props);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDownloadIcon, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "쿠폰받기"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponItem, {
            htmlFor: radioId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponInfo, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                            id: radioId,
                            name: nameText,
                            value: calcObj.totalPrice,
                            disabled: isRadioDisabled,
                            onChange: handleRadio,
                            "data-props": JSON.stringify(props)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponText, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponBadge, {
                                            children: [
                                                discountBadge,
                                                isFcfs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponTagGroup, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTag, {
                                                            type: "limited",
                                                            children: "선착순사용"
                                                        }),
                                                        isImpending && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponTag, {
                                                            type: "impending",
                                                            children: "마감임박"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponName, {
                                            children: couponNm
                                        })
                                    ]
                                }),
                                isFcfs && /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponNotice, {
                                    children: isSoldOut ? "선착순사용 가능 수량이 모두 소진되었습니다." : "예약완료 전 수량이 마감 될 수 있습니다."
                                })
                            ]
                        })
                    ]
                }),
                downloadButton
            ]
        })
    });
};
var CouponPopupComponent = function(props) {
    var ref, ref1;
    var evCd = props.evCd, count = props.count, callback = props.callback, _show = props.show, show = _show === void 0 ? true : _show, close = props.close;
    var ref2 = (0,useCustomerMe/* default */.ZP)(), loginInfo = ref2.data;
    var webCustNo = (ref = loginInfo.body) === null || ref === void 0 ? void 0 : ref.webCustNo;
    var couponFetch = (0,useCouponByUser/* default */.ZP)(evCd, webCustNo);
    var coupon = (ref1 = couponFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var availableRef = (0,react.useRef)();
    var duplicateRef = (0,react.useRef)();
    var summaryRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)({
        availableCoupon: 0,
        duplicateCoupon: 0
    }), discount = ref3[0], setDiscount = ref3[1];
    var ref4 = (0,react.useState)(false), tooltip = ref4[0], setTooltip = ref4[1];
    (0,react.useEffect)(function() {
        if (!tooltip) return;
        var handleClickOutside = function(e) {
            if (summaryRef.current && (0,_instanceof/* default */.Z)(e.target, Node) && !summaryRef.current.contains(e.target)) {
                setTooltip(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        tooltip
    ]);
    var totalPrice = (0,react.useCallback)(function(item) {
        var adtPrice = Number(item.evAdtPrice); // 성인 총상품가
        var chdPrice = Number(item.evChdPrice); // 소아 총상품가
        var infPrice = Number(item.evInfPrice); // 유아 총상품가
        var adtPriceToT = adtPrice * count.A; // 성인 합산가
        var chdPriceToT = chdPrice * count.C; // 소아 합산가
        var infPriceToT = infPrice * count.I; // 유아 합산가
        return adtPriceToT + chdPriceToT + infPriceToT; // 기본상품가 토탈 합산
    }, [
        count
    ]);
    var discountPrice = function(_data) {
        var totalDiscountPrice; // 할인 금액
        var discountInfo; // 성인할인가
        var adtCnt = count.A;
        var chdCnt = count.C;
        var infCnt = count.I;
        if (_data.discDiviCd === "M") {
            // 정액
            totalDiscountPrice = _data.discAmt;
            discountInfo = "(정액할인)";
        } else {
            // 정율
            var adtPriceDiscount = Math.round(_data.evAdtPrice * _data.discRate / 100);
            var chdPriceDiscount = Math.round(_data.evChdPrice * _data.discRate / 100);
            var infPriceDiscount = Math.round(_data.evInfPrice * _data.discRate / 100);
            discountInfo = "(".concat(_data.discRate, "%할인)");
            totalDiscountPrice = adtPriceDiscount * adtCnt + chdPriceDiscount * chdCnt + infPriceDiscount * infCnt;
            if (_data.goodsPriceCd === "TOT" && _data.goodsPriceFr > totalPrice(_data)) {
                totalDiscountPrice = 0;
            } else if (_data.goodsPriceCd === "PER") {
                _data.goodsPriceFr > _data.evAdtPrice && (adtPriceDiscount = 0);
                _data.goodsPriceFr > _data.evChdPrice && (chdPriceDiscount = 0);
                _data.goodsPriceFr > _data.evInfPrice && (infPriceDiscount = 0);
                totalDiscountPrice = adtPriceDiscount * adtCnt + chdPriceDiscount * chdCnt + infPriceDiscount * infCnt;
            }
        }
        return {
            totalPrice: totalDiscountPrice,
            label: "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalDiscountPrice), "원").concat(discountInfo)
        };
    };
    var initCoupon = (0,react.useMemo)(function() {
        var ref;
        if (!coupon) return {
            availableCoupon: [],
            duplicateCoupon: []
        };
        var sysdate = dayjs_min_default()().format("YYYYMMDD");
        var memberGrade = (ref = loginInfo.body) === null || ref === void 0 ? void 0 : ref.custGradeCd;
        var result = coupon.filter(function(item) {
            var remainingCouponCnt = item.issueCnt - item.issueCntTot;
            var isFcfsSoldOut = item.fcfsYn === "Y" && Number(item.remainCnt) <= 0;
            item.tourListNo = null;
            if (item.validityFrDt && item.validityToDt && !(item.validityFrDt <= sysdate && item.validityToDt >= sysdate)) return false;
            // 선착순 사용마감 쿠폰은 목록에 노출 (라디오 비활성)
            if (item.downYn === "Y" && remainingCouponCnt === 0 && item.couponDivi === "BA" && !isFcfsSoldOut) return false;
            if (item.couponDivi !== "BA" && item.downYn === "Y") return false;
            if (item.custGradeCd && memberGrade !== item.custGradeCd) return false;
            if (item.goodsPriceCd === "TOT" && item.goodsPriceFr >= totalPrice(item)) return false;
            if (item.goodsPriceCd === "TOT" && item.goodsPriceTo > 0 && item.goodsPriceTo <= totalPrice(item)) return false;
            if (item.goodsPriceCd === "PER" && item.goodsPriceFr >= item.evAdtPrice) return false;
            if (item.goodsPriceCd === "PER" && item.goodsPriceTo > 0 && item.goodsPriceTo <= item.evAdtPrice) return false;
            if (item.discDiviCd === "M" && !item.goodsPriceCd && item.discAmt > item.evAdtPrice) return false;
            item.calcObj = discountPrice(item);
            if (item.discDiviCd !== "M" && !item.goodsPriceCd && item.calcObj.totalPrice > item.evAdtPrice) return false;
            return true;
        }).sort(function(a, b) {
            return b.calcObj.totalPrice - a.calcObj.totalPrice;
        });
        var availableCoupon = result.filter(function(v) {
            return v.multiUseYn !== "Y";
        }); // 일반
        var duplicateCoupon = result.filter(function(v) {
            return v.multiUseYn === "Y";
        }); // 중복
        return {
            availableCoupon: availableCoupon,
            duplicateCoupon: duplicateCoupon
        };
    }, [
        coupon
    ]);
    var available = initCoupon.availableCoupon;
    var duplicate = initCoupon.duplicateCoupon;
    (0,react.useEffect)(function() {
        // 로그인 체크
        if (!(loginInfo.body.nonUser === false)) close === null || close === void 0 ? void 0 : close();
    }, [
        loginInfo
    ]);
    var couponDataSet = function() {
        var ref, ref1;
        var couponData = [];
        var _available = (ref = availableRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("input:checked");
        var _duplicate = (ref1 = duplicateRef.current) === null || ref1 === void 0 ? void 0 : ref1.querySelector("input:checked");
        if (_available && _available.getAttribute("data-props") !== "false") {
            couponData.push(JSON.parse(_available.getAttribute("data-props")));
        }
        if (_duplicate && _duplicate.getAttribute("data-props") !== "false") {
            couponData.push(JSON.parse(_duplicate.getAttribute("data-props")));
        }
        return couponData;
    };
    var handleRadio = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setDiscount((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discount), (0,_define_property/* default */.Z)({}, name, value)));
    };
    var handleSubmit = function() {
        var couponData = couponDataSet();
        typeof callback === "function" && callback(couponData);
        close === null || close === void 0 ? void 0 : close();
    };
    var handleClose = function() {
        close === null || close === void 0 ? void 0 : close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupConfirm/* default */.ZP, {
        open: !!show,
        title: "할인 쿠폰 선택",
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSelectContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponSectionTitle, {
                                children: "할인쿠폰"
                            }),
                            available.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponList, {
                                ref: availableRef,
                                children: [
                                    available.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react.createElement)(CouponPopup_CouponItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            key: index,
                                            index: index,
                                            handleRadio: handleRadio,
                                            webCustNo: webCustNo,
                                            evCd: evCd
                                        }));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
                                        isNone: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                                            id: "availableCouponNot",
                                            name: "availableCoupon",
                                            value: 0,
                                            onChange: handleRadio,
                                            defaultChecked: true,
                                            "data-props": "false",
                                            children: "쿠폰 사용 안함"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCouponbox, {
                                children: "사용가능한 쿠폰이 없습니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponSectionTitle, {
                                children: "중복 할인 쿠폰"
                            }),
                            duplicate.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CouponList, {
                                ref: duplicateRef,
                                children: [
                                    duplicate.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react.createElement)(CouponPopup_CouponItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            key: index + available.length,
                                            index: index + available.length,
                                            handleRadio: handleRadio,
                                            webCustNo: webCustNo,
                                            evCd: evCd
                                        }));
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponListItem, {
                                        isNone: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioN/* default */.Z, {
                                            id: "duplicateCouponNot",
                                            name: "duplicateCoupon",
                                            value: 0,
                                            onChange: handleRadio,
                                            defaultChecked: true,
                                            "data-props": "false",
                                            children: "쿠폰 사용 안함"
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCouponbox, {
                                children: "사용가능한 쿠폰이 없습니다."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummary, {
                        children: [
                            tooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                                ref: summaryRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰은 노랑풍선 회원만 사용 가능합니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰에 따라 사용 조건이 상이할 수 있으므로 상세 조건을 확인해주세요."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "쿠폰 할인 금액은 최종 결제금액에 따라 변동 될 수 있습니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                "예약 완료 후 적용된 쿠폰은 변경 불가하며, 쿠폰 변경을 원할 경우",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "예약 취소 후 다시 예약해주세요."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "예약 후 인원 취소 및 변경 진행 시, 적용된 쿠폰은 자동 취소 됩니다."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "예약 취소 시 사용된 쿠폰은 복구가 불가합니다."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummaryLabel, {
                                children: [
                                    "할인 금액",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipButton, {
                                        type: "button",
                                        onClick: function() {
                                            return setTooltip(!tooltip);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountSummaryAmount, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                        children: [
                                            "-",
                                            ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(Number(discount.availableCoupon) + Number(discount.duplicateCoupon))
                                        ]
                                    }),
                                    " 원"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupConfirm/* PopupButtonWrap */.EN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* PopupButton */.cy, {
                        types: "cancle",
                        onClick: handleClose,
                        children: "취소"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* PopupButton */.cy, {
                        types: "submit",
                        onClick: handleSubmit,
                        children: "선택완료"
                    })
                ]
            })
        ]
    });
};
var CouponPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponPopupComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_CouponPopup = (/*#__PURE__*/(0,react.memo)(CouponPopup));

// EXTERNAL MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListPopup.tsx + 4 modules
var EventListPopup = __webpack_require__(89071);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/style/detailpackage/point.tsx

function point_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	table + h4 {\n		margin-top: 40px;\n	}\n"
    ]);
    point_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function point_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	margin-bottom: 20px;\n	line-height: 1;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n	> span {\n		padding: 0 3px;\n		font-size: var(--default-size);\n		color: var(--gray-color);\n	}\n"
    ]);
    point_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function point_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 40px;\n	margin-top: 40px;\n	background: #f3f3f3;\n"
    ]);
    point_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function point_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	align-items: center;\n	line-height: 1;\n	font-size: var(--default-size);\n	color: var(--emp-color);\n	&::before {\n		display: inline-block;\n		width: 18px;\n		height: 19px;\n		padding-right: 10px;\n		background: url(",
        ') no-repeat 0 -266px;\n		vertical-align: middle;\n		content: "";\n	}\n'
    ]);
    point_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function point_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 10px;\n	> li + li {\n		margin-top: 10px;\n	}\n"
    ]);
    point_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function point_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin-top: 40px;\n"
    ]);
    point_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function point_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	padding: 20px 40px;\n	margin-bottom: 40px;\n	border: 1px solid var(--line-color);\n	> li {\n		position: relative;\n		display: flex;\n		justify-content: space-between;\n		&::before {\n			position: absolute;\n			top: 50%;\n			left: -10px;\n			display: block;\n			width: 4px;\n			height: 4px;\n			border-radius: 50%;\n			background-color: var(--bl-color);\n			transform: translateY(-50%);\n			content: "";\n		}\n		> span > em {\n			margin-right: 5px;\n		}\n	}\n	> li + li {\n		margin-top: 10px;\n	}\n'
    ]);
    point_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function point_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: fit-content;\n	text-align: left;\n	text-decoration: underline;\n	",
        "\n\n	&:active, &:hover {\n		text-decoration: underline;\n	}\n"
    ]);
    point_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function point_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	cursor: pointer;\n"
    ]);
    point_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function point_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 40px;\n	table {\n		td {\n			padding: 0 10px;\n		}\n	}\n"
    ]);
    point_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var point_Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f5bf1dda-0"
})(point_templateObject());
var SubTitle = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-f5bf1dda-1"
})(point_templateObject1());
var NotiBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f5bf1dda-2"
})(point_templateObject2());
var InfoTitle = styled_components_browser_esm["default"].h5.withConfig({
    componentId: "sc-f5bf1dda-3"
})(point_templateObject3(), (ico_spr_default()));
var BulletList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-f5bf1dda-4"
})(point_templateObject4());
var BtnArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f5bf1dda-5"
})(point_templateObject5());
var PointWrap = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-f5bf1dda-6"
})(point_templateObject6());
var PromotionName = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-f5bf1dda-7"
})(point_templateObject7(), (0,desktop_text/* Ellipsis */.mH)(1));
var LinkTr = styled_components_browser_esm["default"].tr.withConfig({
    componentId: "sc-f5bf1dda-8"
})(point_templateObject8());
var TableWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f5bf1dda-9"
})(point_templateObject9());


// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 3 modules
var layout = __webpack_require__(47178);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 4 modules
var popup = __webpack_require__(16628);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventMileage.ts
var useEventMileage = __webpack_require__(98846);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/PointSavePop.tsx
















var PointSavePopComponent = function(props) {
    var ref;
    var evCd = props.evCd, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "evCd"
    ]);
    var eventMileage = (0,useEventMileage/* default */.ZP)(evCd);
    var mileage = (ref = eventMileage.data) === null || ref === void 0 ? void 0 : ref.body;
    var adtMlgPoint = function(item) {
        var mlgPoint = item.mlgPoint;
        if (item.mlgSaveKindCd === "R1") {
            mlgPoint = Math.round((item.adtPrice + item.airtaxAdtCost + item.bafAdtCost) * item.mlgPoint / 100);
        }
        return mlgPoint;
    };
    var saveDt = function(item) {
        var mlgSaveDtCd = item.mlgSaveDtCd, evArriveDt = item.evArriveDt, stdDay = item.stdDay, stdMonth = item.stdMonth, stdYear = item.stdYear, fixSaveDt = item.fixSaveDt;
        var mlgSaveDt = "";
        if (mlgSaveDtCd === "N1") {
            mlgSaveDt = "즉시";
        } else if (mlgSaveDtCd === "S1") {
            mlgSaveDt = dayjs_min_default()(evArriveDt).add(stdDay, "day").add(stdMonth, "month").add(stdYear, "year").format("YYYY년 MM월 DD일");
        } else if (mlgSaveDtCd === "F1") {
            mlgSaveDt = dayjs_min_default()(fixSaveDt).format("YYYY년 MM월 DD일");
        }
        return mlgSaveDt;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
            title: "적립 예상 노랑풍선 포인트",
            size: "regular",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(point_Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                        children: [
                            "적립 예상 포인트",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: mileage && saveDt(mileage[0])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointWrap, {
                        children: mileage && mileage.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            item.mlgGb,
                                            " (성인 1인 기준)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* BlueText */.IW, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(adtMlgPoint(item))
                                            }),
                                            "P"
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    }),
                    mileage && mileage.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableWrap, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                children: "진행중인 프로모션"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                                types: "vertical",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                                        children: "적립 예상 포인트 정보"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                style: {
                                                    width: "58%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                style: {
                                                    width: "15%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                                style: {
                                                    width: "27%"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "프로모션"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "적립"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        scope: "col",
                                                        children: "기간"
                                                    })
                                                ]
                                            }),
                                            mileage.map(function(item, index) {
                                                var link = item.webBannerLink === "OUTLINK" ? item.bnrLink : "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/promotion/promotionDetail.yb?mstNo=").concat(item.bnrMstNo);
                                                return index !== 0 && item.mlgDivi === "MLG" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionName, {
                                                                href: link,
                                                                target: "_blank",
                                                                onClick: function(e) {
                                                                    return (0,commonUtil/* onClickSSO */.Zy)(e, link);
                                                                },
                                                                children: item.promotionNm
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                            children: [
                                                                item.mlgPoint,
                                                                item.mlgUnit
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                            children: [
                                                                dayjs_min_default()(item.mlgStartDt).format("YYYY.MM.DD"),
                                                                "~",
                                                                dayjs_min_default()(item.mlgEndDt).format("YYYY.MM.DD")
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            }),
                                            mileage.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 3,
                                                    children: "진행중인 프로모션이 없습니다."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* NoteBox */.ug, {
                        icon: "question",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "유의사항"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "만 14세 이상 노랑풍선 회원만 적립 가능합니다. (여행객 개별 적립)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "포인트는 온라인 회원가입(포인트 동의 포함) 후 실제 여행을 다녀오신 여행자를 대상으로 개별 적립됩니다. (만 14세 미만 포인트 적립 불가)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "여행상품 구매 및 여행 완료 후 결제금액의 1% 포인트를 적립해드립니다. (1포인트 =1원)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "결제 시 포인트로 사용한 금액 및 할인을 제외한 나머지 금액에 대하여 포인트를 적립해드립니다."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                                        children: [
                                            "여행 완료 후 한국 도착일 기준 7일째 되는 날 자정에 자동 적립됩니다.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "예) 2023년 1월 1일 도착(귀국)했을 경우 → 1월 7일까지 회원가입 완료 및 내 예약 찾기/매핑 완료 →",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "1월 8일 00시 자동 적립"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "비회원의 경우 자동적립일 기준일 이전에 회원가입 후 별도 적립됩니다. (적립 기준일 이후에는 포인트 적립 불가)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "프로모션 / 이벤트에 따라 정책 및 적립 기준일 상이해, 프로모션 정책이 포인트 정책보다 우선 적용될 수 있습니다."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "적립 가능 상품 : 적립 불가 상품을 제외한 국내/외 여행 상품"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                                        children: [
                                            "적립 불가 상품 : 자유여행(항공권/호텔/액티비티/KTX/렌터카 등), 패키지여행(단품, 특가상품), 홈쇼핑/일반 제휴/",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "소셜 커머스 상품, 그 외 노랑풍선 지정 일부 상품"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                                        children: [
                                            "포인트 결제 가능 : 국내/해외 여행상품, 실시간 해외 항공권(일부 불가 조건 아래 참고),",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "실시간 호텔, 액티비티, KTX, 렌터카"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "포인트 결제 불가 : 실시간 항공권, 외부 채널 상품(제휴 채널, 홈쇼핑 등), 그 외 노랑풍선 지정 일부 상품"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* BulletListItem */.yx, {
                                        children: "추가 적립 프로모션은 중복으로 적용되지 않으며, 가장 큰 혜택을 제공하는 1개 프로모션 기준으로 적립됩니다."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }))
    });
};
var PointSavePop = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "PointSavePop Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointSavePopComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_PointSavePop = (PointSavePop);

// EXTERNAL MODULE: ./components/style/detailpackage/snb.tsx
var snb = __webpack_require__(22476);
// EXTERNAL MODULE: ./framework/ui/desktop/button/CountingButton.tsx
var CountingButton = __webpack_require__(26195);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventAvailability.ts
var useEventAvailability = __webpack_require__(69230);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventPrice.ts
var useEventPrice = __webpack_require__(8745);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOneAvailEvent.ts
var useGoodsOneAvailEvent = __webpack_require__(51820);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailSnb.tsx
































var DetailSNBComponent = function(props) {
    var ref, ref1, ref2;
    var event = props.eventDetail;
    var goodsCd = event.goodsCd, evCd = event.evCd;
    var ref3 = (0,useCustomerMe/* default */.ZP)(), loginInfo = ref3.data;
    var eventPriceFetch = (0,useEventPrice/* default */.ZP)(evCd);
    var price = (0,eventUtil/* getPrice */.aS)((ref = eventPriceFetch.data) === null || ref === void 0 ? void 0 : ref.body);
    var eventMileageFetch = (0,useEventMileage/* default */.ZP)(evCd);
    var mileage = (ref1 = eventMileageFetch.data) === null || ref1 === void 0 ? void 0 : ref1.body;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GORV"); // WEB_CONT_DIVI_CD 상품상세_요금영역
    var bannerContents = (ref2 = bannerContentsFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)("slideIn"), 1), slide = ref5[0];
    var maxCount = 30;
    // 패밀리 상품(familyYn === "Y")은 성인 2, 아동 2, 유아 0으로 기본 세팅
    var ref6 = (0,react.useState)(event.familyYn === "Y" ? {
        A: 2,
        C: 2,
        I: 0
    } : {
        A: 1,
        C: 0,
        I: 0
    }), count = ref6[0], setCount = ref6[1];
    var ref7 = (0,react.useState)([]), coupon = ref7[0], setCoupon = ref7[1];
    // 쿠폰 할인금액
    var discount = (0,react.useMemo)(function() {
        return coupon.reduce(function(acc, cur) {
            return acc + cur.calcObj.totalPrice;
        }, 0);
    }, [
        coupon
    ]);
    // 총액
    var totalPrice = (0,react.useMemo)(function() {
        if (!price) return 0;
        return price.adult * count.A + price.child * count.C + price.infant * count.I - discount;
    }, [
        count,
        price,
        discount
    ]);
    // + - 버튼
    var calculation = (0,react.useCallback)(function(type) {
        return function(number) {
            if (number > maxCount) return;
            if (discount > 0) {
                open(function(prop) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                        text: "쿠폰을 재적용 해주세요."
                    }));
                });
                setCoupon([]);
                return;
            }
            setCount(function(cur) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), (0,_define_property/* default */.Z)({}, type, number));
            });
        };
    }, [
        discount
    ]);
    /** 쿠폰 open */ var openPopCoupon = function() {
        var callbackCoupon = function(prop) {
            setCoupon(prop);
        };
        if ((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.body.nonUser) === false) {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_CouponPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    evCd: evCd,
                    count: count,
                    callback: callbackCoupon
                }));
            });
        } else {
            open(function(prop) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                    alertType: "confirm",
                    text: "로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?",
                    afterConfirm: function() {
                        return LoginUtil.login();
                    }
                }));
            });
        }
    };
    /** 포인트 적립 안내 open */ var openPopPointSave = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_PointSavePop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                evCd: evCd
            }));
        });
    };
    /** 출발일보기 slide */ var openPopEventList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, body, availEvent, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,useGoodsOneAvailEvent/* goodsAvailEventAsync */.iS)(goodsCd)
                        ];
                    case 1:
                        result = _state.sent();
                        body = result.data.body;
                        _tmp = {};
                        _tmp1 = {};
                        availEvent = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)(_tmp, body), (_tmp1.evStartDt = event.evStartDt, _tmp1));
                        slide(function(prop) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                                goodsCd: goodsCd,
                                availEvent: availEvent
                            }));
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function openPopEventList() {
            return _ref.apply(this, arguments);
        };
    }();
    /** 예약하기 버튼 텍스트 */ var reserveText = (0,eventUtil/* reserveButtonText */._f)(event);
    /** 예약하기 버튼 */ var handleReserve = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, isValidFamily, msg, ref2, eventAvailability, adtCnt, chdCnt, infCnt, ref3, menu, dspSid, couponParams, nextUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 패밀리 상품은 (성인2 + 아동2)의 배수여야 예약 가능 (유아는 조건에 영향 없음)
                        if (event.familyYn === "Y") {
                            isValidFamily = count.A === count.C && count.A > 0 && count.A % 2 === 0;
                            if (!isValidFamily) {
                                MessageUtil.alert("패밀리팩 상품입니다.<br/>성인과 아동 인원을 동일하게 선택해 주세요.<br/>(예: 성인 2명 + 아동 2명)");
                                return [
                                    2
                                ];
                            }
                        }
                        msg = "";
                        if (reserveText[1] === "예약마감") {
                            msg = "예약이 마감되었습니다.<br/>출발일 변경에서 예약가능 상품으로 예약하시거나,<br/>담당자에게 문의 해주세요.";
                        } else if (reserveText[1] === "출발완료") {
                            msg = "이미 출발한 상품입니다.<br/>출발일 변경에서 예약가능 상품으로 예약하시거나,<br/>담당자에게 문의 해주세요.";
                        }
                        if (!(event.fixRervCd === "YT")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,useEventAvailability/* eventAvailabilityAsync */.$o)(evCd)
                        ];
                    case 1:
                        eventAvailability = _state.sent();
                        if (((ref2 = eventAvailability.data) === null || ref2 === void 0 ? void 0 : ref2.body) < count.A + count.C + count.I) {
                            msg = "예약 가능 인원을 초과하였습니다.<br/>담당자에게 문의해 주세요.";
                        }
                        _state.label = 2;
                    case 2:
                        if (msg) {
                            MessageUtil.alert(msg);
                            return [
                                2
                            ];
                        }
                        adtCnt = count.A > 1 ? "".concat(count.A) : "1";
                        chdCnt = count.C > 0 ? "".concat(count.C) : "0";
                        infCnt = count.I > 0 ? "".concat(count.I) : "0";
                        menu = (ref3 = (ref = (0,commonUtil/* getQueryParams */.vl)(location.search)) === null || ref === void 0 ? void 0 : ref.menu) !== null && ref3 !== void 0 ? ref3 : "";
                        dspSid = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.dspSid;
                        couponParams = coupon.map(function(v) {
                            return v.couponNo;
                        }).join(",");
                        nextUrl = "".concat(config_public/* default.ENV_TRAVEL_URL */.Z.ENV_TRAVEL_URL, "/pkg/reserve?evCd=").concat(evCd, "&adtCnt=").concat(adtCnt, "&chdCnt=").concat(chdCnt, "&infCnt=").concat(infCnt, "&menu=").concat(menu, "&dspSid=").concat(dspSid).concat(couponParams ? "&coupon=".concat(couponParams) : "");
                        /* 로그인 안되어있으면 로그인페이지 이동 */ if (!((loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.body.nonUser) === false)) {
                            LoginUtil.loginRsvn(nextUrl);
                            return [
                                2
                            ];
                        }
                        (0,commonUtil/* hrefSSO */.VQ)(nextUrl);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReserve() {
            return _ref.apply(this, arguments);
        };
    }();
    // tagging 기획전 배너
    var ref8 = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_dtl"), taggingClickBanner = ref8.taggingClick;
    // tagging 출발일 보기
    var ref9 = (0,useTagging/* useTaggingClick */.b)("pkg_select_dtl_change", event), taggingClickChange = ref9.taggingClick;
    // tagging 예약하기
    var ref10 = (0,useTagging/* useTaggingClick */.b)("pkg_select_evCd_pkgDtl", {
        eventDetail: event,
        count: {
            adultCnt: count.A,
            childCnt: count.C,
            infantCnt: count.I
        },
        coupon: coupon
    }), taggingClickReserve = ref10.taggingClick;
    var _mgmUserTelNo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Box */.xu, {
        isFixed: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* ScrollWrap */.Il, {
                isOption: event.accomNm && event.webDisplayCls === "B",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* DepartureWrap */.b0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* InfoList */.Q4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "출발"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: (0,eventUtil/* departureStart */.jn)(event)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "도착"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: (0,eventUtil/* returnArrival */.jp)(event)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "교통"
                                            }),
                                            event.trTp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Flex */.kC, {
                                                gap: "10",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                                    img: (0,eventUtil/* getTrafficIconUrl */.wz)(event),
                                                    title: event.trCompanyNm
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: "교통불포함"
                                            })
                                        ]
                                    }),
                                    event.accomNm && event.webDisplayCls === "B" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "옵션"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: event.accomNm
                                            })
                                        ]
                                    }),
                                    !(0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "남은좌석"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: event.evStaCd === "05" ? "마감" : "".concat(event.avlilBlockQty, "석")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* DepartureButton */.eq, {
                                types: "subCtn",
                                text: "출발일 변경",
                                size: "large",
                                onClick: function() {
                                    openPopEventList();
                                    taggingClickChange();
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceWrap */.PS, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "성인"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.adult),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.A,
                                        minValue: 1,
                                        increase: calculation("A"),
                                        decrease: calculation("A")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "아동"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && (price === null || price === void 0 ? void 0 : price.child) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.child),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.C,
                                        increase: calculation("C"),
                                        decrease: calculation("C")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Assort */.Fs, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Age */.ZA, {
                                                children: "유아"
                                            }),
                                            (0,eventUtil/* isGoodsTpFH */.mk)(event.goodsTp) && (price === null || price === void 0 ? void 0 : price.infant) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: "별도문의"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceText */.Xd, {
                                                children: [
                                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(price === null || price === void 0 ? void 0 : price.infant),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "원"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountingButton/* default */.Z, {
                                        value: count.I,
                                        increase: calculation("I"),
                                        decrease: calculation("I")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* CouponWrap */.xZ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Coupon */.wV, {
                                children: "할인쿠폰"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: openPopCoupon,
                                children: "쿠폰 적용"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "쿠폰할인"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* Discount */.sz, {
                                children: [
                                    "-",
                                    ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(discount),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "원"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* TotalWrap */.lU, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snb/* PriceInfo */.a8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: openPopPointSave,
                                children: "포인트 적립 안내"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "(성인1인기준) ",
                                    mileage && ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber((0,goodsUtil/* getExpectMileage */.bd)(mileage)),
                                    "P 적립예정"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* TotalPrice */.Mh, {
                        $disabled: reserveText[0] === "disabled",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(totalPrice)
                                }),
                                "원"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Reservation */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* ReservationButton */._G, {
                            types: reserveText[0],
                            text: reserveText[1],
                            isDisabled: reserveText[0] === "disabled",
                            waiting: reserveText[1] === "대기예약",
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            taggingClickReserve();
                                            return [
                                                4,
                                                handleReserve()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })
                        })
                    }),
                    bannerContents && bannerContents.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* Banner */.jL, {
                            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link),
                            target: (0,commonUtil/* getTarget */.U9)(item.target),
                            onClick: function(e) {
                                taggingClickBanner((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    selectDiv: "reserveBanner"
                                }));
                                (0,commonUtil/* onClickSSO */.Zy)(e, "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link));
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.imgPath ? "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath) : (ico_nodata_default()),
                                alt: item.alt
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snb/* ManagerBox */.Ik, {
                children: event.mgmUserInfo === "Y" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                            children: event.mgmDeptNm
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            children: event.phoneDirect
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                            children: [
                                "담당자 ",
                                event.mgmUserNm
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            children: (_mgmUserTelNo = event.mgmUserTelNo) !== null && _mgmUserTelNo !== void 0 ? _mgmUserTelNo : event.phoneDirect
                        })
                    ]
                })
            })
        ]
    });
};
var DetailSNB = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailSnb Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSNBComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var DetailSnb = (/*#__PURE__*/(0,react.memo)(DetailSNB));

// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts
var useConfigureAxios = __webpack_require__(83839);
;// CONCATENATED MODULE: ./pages/product/detailPackage.page.tsx




function detailPackage_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	@media print {\n		display: none;\n\n		#printPopup {\n			display: block;\n		}\n	}\n"
    ]);
    detailPackage_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}























var detailPackage_page_Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a95212f7-0"
})(detailPackage_page_templateObject());
/* 최근 본 상품 저장 **/ var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var Page = function(props) {
    var ref, ref1;
    /** 예외처리 */ (0,react.useEffect)(function() {
        if (props.message) {
            alert(props.message);
            location.href = "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL);
        }
    }, []);
    if (props.message) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    /** 정상 */ var query = props.query, eventDetail = props.eventDetail, goodsImage = props.goodsImage;
    /** 로그인 정보 */ var signin = (0,useCustomerMe/* default */.ZP)();
    var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.webCustNo) || "";
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /** 최근 본 상품 SET */ var setRecently = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(eventDetail, goodsImage) {
            var webCustId, ref, userId, evCd, evStartDt, outDeprtTm, evArriveDt, inArrvTm, trCompanySnm, trCompanyNm, trTp, pathname, queries, search, detailedUrl, imgUrl, _evCd, goodsId, _evNm, goodsName, type, viewDate, category, soldoutYn, trafficCode, _tmp, dayOfWeekStart, dayOfWeekArrive, outDeprtTime, inArrvTime, information, result, _tmp1, _tmp2, e;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        webCustId = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                        userId = (0,commonUtil/* getCookie */.ej)("userId");
                        if (!userId) return [
                            2
                        ];
                        evCd = eventDetail.evCd, evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, evArriveDt = eventDetail.evArriveDt, inArrvTm = eventDetail.inArrvTm, trCompanySnm = eventDetail.trCompanySnm, trCompanyNm = eventDetail.trCompanyNm, trTp = eventDetail.trTp;
                        pathname = location.pathname;
                        queries = (0,commonUtil/* getQueryParams */.vl)();
                        search = "?menu=".concat(queries.menu, "&dspSid=").concat(queries.dspSid, "&evCd=").concat(evCd);
                        detailedUrl = "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL).concat(pathname).concat(search);
                        imgUrl = ((ref = goodsImage[0]) === null || ref === void 0 ? void 0 : ref.imageThum3) || "";
                        goodsId = (_evCd = eventDetail.evCd) !== null && _evCd !== void 0 ? _evCd : "";
                        goodsName = (_evNm = eventDetail.evNm) !== null && _evNm !== void 0 ? _evNm : "";
                        type = eventDetail.goodsTp === "D" ? "DMT" : "PKG";
                        viewDate = dayjs_min_default()().format("YYYY.MM.DD HH:mm:ss");
                        category = (0,goodsUtil/* goodsTpLabel */.mk)(eventDetail.goodsTp).join(";");
                        soldoutYn = "";
                        _tmp = {};
                        trafficCode = (_tmp.A = trCompanySnm, _tmp.T = "TRAIN", _tmp.S = "SHIP", _tmp.B = "BUS", _tmp)[trTp] || "ETC";
                        dayOfWeekStart = daykor[dayjs_min_default()(evStartDt).day()];
                        dayOfWeekArrive = daykor[dayjs_min_default()(evArriveDt).day()];
                        outDeprtTime = outDeprtTm ? "".concat(outDeprtTm.slice(0, 2), ":").concat(outDeprtTm.slice(2)) : "";
                        inArrvTime = inArrvTm ? "".concat(inArrvTm.slice(0, 2), ":").concat(inArrvTm.slice(2)) : "";
                        information = "".concat(dayjs_min_default()(evStartDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekStart, ");").concat(outDeprtTime, ";") + "".concat(dayjs_min_default()(evArriveDt).format("YYYY.MM.DD"), ";(").concat(dayOfWeekArrive, ");").concat(inArrvTime, ";") + "".concat(trafficCode, ";").concat(trTp ? trCompanyNm : "교통불포함");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _tmp1 = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp1.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/user/recentlyViewed"), _tmp1.method = "POST", _tmp1.data = {
                                imgUrl: imgUrl,
                                goodsId: goodsId,
                                goodsName: goodsName,
                                information: information,
                                type: type,
                                viewDate: viewDate,
                                userId: userId,
                                detailedUrl: detailedUrl,
                                webCustId: webCustId,
                                category: category,
                                soldoutYn: soldoutYn
                            }, _tmp1))
                        ];
                    case 2:
                        result = _state.sent();
                        _tmp2 = {};
                        if (result.data.code === "0000") queryClient.refetchQueries((_tmp2.queryKey = [
                            "useGetRecently"
                        ], _tmp2.type = "active", _tmp2));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function setRecently(eventDetail, goodsImage) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!signin.isFetching) {
            setRecently(eventDetail, goodsImage, webCustNo);
        }
    }, [
        signin
    ]);
    // tagging
    (0,useTagging/* useTaggingLoad */.q)("pkg_view_dtl", eventDetail);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(detailPackage_page_Wrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Desktop/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Container */.W2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailHeader/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* DescriptionWrap */._O, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSnb, {
                                        eventDetail: eventDetail
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* DescriptionContent */.jb, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailContents/* default */.ZP, (0,_object_spread/* default */.Z)({}, props)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailSchedule/* default */.Z, (0,_object_spread/* default */.Z)({}, query)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_DetailPromotion, (0,_object_spread/* default */.Z)({}, query))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_DetailRecommend, (0,_object_spread/* default */.Z)({}, query))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMTags/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var detailPackage_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7700,2335,1708,8866,1712,2352,1863,2854,6031,7372,552,764,7834,2349,1877,3460,2045,4158,9774,2888,179], function() { return __webpack_exec__(21728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);